import { render, staticRenderFns } from "./PodcastIcon.vue?vue&type=template&id=63529040&"
import script from "./PodcastIcon.vue?vue&type=script&lang=js&"
export * from "./PodcastIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports